import { getTcuList } from "api/appointment/GetTcuList/getTcuList";
import { TcuInstitutionPayload } from "api/appointment/GetTcuList/getTcuList.fromApi.types";
import { AxiosError } from "axios";
import { useEffect, useState } from "react";

const useGetTcuList = (
  memberIdentifier: string,
): {
  tcuList: TcuInstitutionPayload[] | null;
  isLoadingTcuList: boolean;
  hasErroredTcuList: boolean;
  errorMessageTcuList: string | null;
} => {
  const [tcuList, setTcuList] = useState<TcuInstitutionPayload[] | null>(null);
  const [isLoadingTcuList, setIsLoadingTcuList] = useState(false);
  const [hasErroredTcuList, setHasErroredTcuList] = useState<boolean>(false);
  const [errorMessageTcuList, setErrorMessageTcuList] = useState<string | null>(
    null,
  );

  useEffect(() => {
    // If memberIdentifier is not provided, do not fetch TCU list
    if (!memberIdentifier) {
      return;
    }
    (async () => {
      setIsLoadingTcuList(true);

      try {
        const responseData = await getTcuList(memberIdentifier);

        setTcuList(responseData.TcuList);
        setHasErroredTcuList(false);
        setErrorMessageTcuList(null);
      } catch (error) {
        setTcuList(null);
        setHasErroredTcuList(true);
        if (error instanceof AxiosError) {
          setErrorMessageTcuList(error.response?.data.Message);
        } else {
          setErrorMessageTcuList(null);
        }
      } finally {
        setIsLoadingTcuList(false);
      }
    })();
  }, [memberIdentifier]);

  return { tcuList, isLoadingTcuList, hasErroredTcuList, errorMessageTcuList };
};

export { useGetTcuList };
